/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type { OrganizationCurrency } from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const getCurrencies = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<OrganizationCurrency[]>> => {
    return axios.get(`/api/currencies`, options);
};

export const getGetCurrenciesQueryKey = () => {
    return [`/api/currencies`] as const;
};

export const getGetCurrenciesQueryOptions = <
    TData = Awaited<ReturnType<typeof getCurrencies>>,
    TError = AxiosError<null>,
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<typeof getCurrencies>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetCurrenciesQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrencies>>> = ({
        signal,
    }) => getCurrencies({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getCurrencies>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCurrenciesQueryResult = NonNullable<
    Awaited<ReturnType<typeof getCurrencies>>
>;
export type GetCurrenciesQueryError = AxiosError<null>;

export function useGetCurrencies<
    TData = Awaited<ReturnType<typeof getCurrencies>>,
    TError = AxiosError<null>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getCurrencies>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getCurrencies>>,
                    TError,
                    Awaited<ReturnType<typeof getCurrencies>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCurrencies<
    TData = Awaited<ReturnType<typeof getCurrencies>>,
    TError = AxiosError<null>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getCurrencies>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getCurrencies>>,
                    TError,
                    Awaited<ReturnType<typeof getCurrencies>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCurrencies<
    TData = Awaited<ReturnType<typeof getCurrencies>>,
    TError = AxiosError<null>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getCurrencies>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCurrencies<
    TData = Awaited<ReturnType<typeof getCurrencies>>,
    TError = AxiosError<null>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getCurrencies>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetCurrenciesQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetCurrenciesSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getCurrencies>>,
    TError = AxiosError<null>,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof getCurrencies>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetCurrenciesQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrencies>>> = ({
        signal,
    }) => getCurrencies({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getCurrencies>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCurrenciesSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getCurrencies>>
>;
export type GetCurrenciesSuspenseQueryError = AxiosError<null>;

export function useGetCurrenciesSuspense<
    TData = Awaited<ReturnType<typeof getCurrencies>>,
    TError = AxiosError<null>,
>(
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getCurrencies>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCurrenciesSuspense<
    TData = Awaited<ReturnType<typeof getCurrencies>>,
    TError = AxiosError<null>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getCurrencies>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCurrenciesSuspense<
    TData = Awaited<ReturnType<typeof getCurrencies>>,
    TError = AxiosError<null>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getCurrencies>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCurrenciesSuspense<
    TData = Awaited<ReturnType<typeof getCurrencies>>,
    TError = AxiosError<null>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getCurrencies>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetCurrenciesSuspenseQueryOptions(options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}
